import { ReactNode } from 'preact/compat';
import { Experiment, useActiveVariant, Variant } from 'zl-shared/dist/ab-test';

import { useSelector } from '@/redux/helper';

import EXPERIMENTS, { HomePageVariant } from './experiments';

const LandingPageExperiment = ({ children }: { children: ReactNode }) => {
  const isLogged = useSelector((state) => state.user.logged);

  // only test for logged in users
  if (!isLogged) {
    return children;
  }

  return (
    <Experiment name={EXPERIMENTS.defaultHomePage.name}>
      {EXPERIMENTS.defaultHomePage.variants.map(({ name: variant }) => (
        <Variant key={variant} name={variant}>
          {children}
        </Variant>
      ))}
    </Experiment>
  );
};

export const useLandingPageVariant = () => useActiveVariant(EXPERIMENTS.defaultHomePage.name) as HomePageVariant | undefined;
export const useIsHomePageVariant = () => useLandingPageVariant() === 'home';
export const useIsMapPageVariant = () => useLandingPageVariant() === 'map';

export default LandingPageExperiment;
